import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import './EditArticle.css'
import axios from 'axios'
import MyNavbar from '../../components/navbar/MyNavbar'
import { Button, Form } from 'react-bootstrap'
import Swal from 'sweetalert2'

function EditArticle() {

    const [articleData , setArticleData] = useState({})

    // we use useParams for get id and save on articleId .
    const articleId = useParams().articleId

    // we define this hooks for edit btn after edit aricle be success we come back to main page.
    const navigate = useNavigate()

    // send our reqest to api with useEffect
    useEffect(() => {
        axios.get(`http://localhost/react/api/articles/?id=${articleId}`)
        .then(response => setArticleData(response.data.data[0]))

    } , [])

    // edit btn function 
    // we use this function below in edit btn.
    const editArticleHandler = () => {
        // we use articleId to access id in aricles and use articleData to access new values in form for change the values inside
        axios.put(`http://localhost/react/api/articles/?id=${articleId}` , articleData)
        Swal.fire({
            title : 'The article has been edited successfully',
            timer : 2000,
            timerProgressBar : true,
            timerConfirmButton : true

        })
        // we use navigate here for come back to main page.
            navigate('/')
    }

    // formHandler 
    const formHandler = (e) => {
        // we use name propety from form.control
        setArticleData({...articleData , [e.target.name] : e.target.value})

    }

    return(
        <>
      <MyNavbar />
      <div className='form-container'>
        <Form>
          {/* first form */}
          <Form.Group className="mb-3">
            <Form.Label>Article title :</Form.Label>
            {/* we use name property in to the formhandler function to get info and values. */}
            <Form.Control value={articleData.title} name='title' onChange={formHandler} type="text" placeholder="Enter the title of the article" required />
          </Form.Group>
          {/* second form */}
          <Form.Group className="mb-3">
            <Form.Label>Short description :</Form.Label>
            <Form.Control value={articleData.description} name='description' onChange={formHandler} type="text" placeholder="Enter a short description about the article" required />
          </Form.Group>
          {/*third form*/}
          <Form.Group className="mb-3">
            <Form.Label>Article image :</Form.Label>
            <Form.Control value={articleData.image} name='image' onChange={formHandler} type="text" placeholder="Enter the image address of the article" />
          </Form.Group>
          {/* fourth form */}
           <Form.Group className="mb-3">
            <Form.Label>Reading time :</Form.Label>
            <Form.Control value={articleData.readingTime} name='readingTime' onChange={formHandler} type="number" placeholder="Enter the reading time of the article" />
          </Form.Group>
          {/* fifth form */}
          <Form.Group className="mb-3">
            <Form.Label>Article category :</Form.Label>
            <Form.Control value={articleData.category} name='category' onChange={formHandler} type="text" placeholder="Enter the category of the article" />
          </Form.Group>
          {/* sixth form */}
          <Form.Group className="mb-3">
            <Form.Label>Article author :</Form.Label>
            <Form.Control value={articleData.writter} name='writter' onChange={formHandler} type="text" placeholder="Enter name of the author of the article" />
          </Form.Group>
          {/* give onclick function for edit a article */}
          <Button onClick={editArticleHandler} className='btn-form' variant="success" type="button">Edit a Article</Button>
        </Form>
      </div>
    </>
    )
}

export default EditArticle